import { createBrowserRouter, Navigate, useParams } from 'react-router';
import { Center } from '@astryxdesign/core/Center';
import { VStack } from '@astryxdesign/core/VStack';
import { Heading } from '@astryxdesign/core/Heading';
import { Text } from '@astryxdesign/core/Text';
import { TenantRoot } from './tenant-context';
import { ClientLayout } from '../features/storefront/ClientLayout';
import { HomePage } from '../features/storefront/HomePage';
import { ServicesPage } from '../features/storefront/ServicesPage';
import { MyBookingPage } from '../features/storefront/MyBookingPage';

const owner = () => import('../features/owner/index.ts');

function NoTenant() {
  return (
    <Center height="100dvh">
      <VStack gap={2} padding={4} hAlign="center">
        <Heading level={1}>Онлайн-запись</Heading>
        <Text type="supporting" justify="center">Откройте ссылку студии вида /s/название/ — её присылает студия.</Text>
      </VStack>
    </Center>
  );
}

function TenantNotFoundPage() {
  const { slug } = useParams();
  return <Navigate to={`/s/${slug}/`} replace />;
}

export const router = createBrowserRouter([
  {
    path: '/s/:slug',
    element: <TenantRoot />,
    children: [
      {
        element: <ClientLayout />,
        children: [
          { index: true, element: <HomePage /> },
          { path: 'services', element: <ServicesPage /> },
          { path: 'my', element: <MyBookingPage /> },
        ],
      },
      {
        path: 'owner',
        lazy: async () => ({ Component: (await owner()).OwnerRoot }),
        children: [
          { index: true, lazy: async () => ({ Component: (await owner()).AgendaPage }) },
          { path: 'stats', lazy: async () => ({ Component: (await owner()).StatsPage }) },
          { path: 'settings', lazy: async () => ({ Component: (await owner()).SettingsPage }) },
          { path: 'assistant', lazy: async () => ({ Component: (await owner()).OwnerAssistantPage }) },
        ],
      },
      { path: '*', element: <TenantNotFoundPage /> },
    ],
  },
  { path: '*', element: <NoTenant /> },
]);
